import { render, staticRenderFns } from "./situation-random.vue?vue&type=template&id=2a88987f"
import script from "./situation-random.vue?vue&type=script&lang=js"
export * from "./situation-random.vue?vue&type=script&lang=js"
import style0 from "./situation-random.vue?vue&type=style&index=0&id=2a88987f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports